import React from "react";
import useBreakpoints from "~/hooks/useBreakpoints";
import DownArrow from "./DownArrow";

export const MenuBrandItem: React.FC<React.PropsWithChildren> = ({
  children,
}) => (
  <li className="flex max-h-[calc(max(85px,12vh))] max-w-[250px] flex-shrink flex-grow basis-[45%] items-center justify-center md:flex md:h-auto md:w-[8.125rem] md:basis-[20%]">
    {children}
  </li>
);

export const MenuBrandViewAll: React.FC = () => {
  const { isMobile } = useBreakpoints();

  return (
    <a
      href="/brands"
      className="mx-auto mt-6 flex w-full items-center justify-center gap-2 text-sm underline md:mt-2.5 md:h-12 md:fill-blue400 md:text-blue400"
    >
      {isMobile ? (
        "CHECK OUT ALL BRANDS"
      ) : (
        <>
          View All
          <DownArrow />
        </>
      )}
    </a>
  );
};

export const MenuLink: React.FC<React.PropsWithChildren<{ href?: string }>> = ({
  href,
  children,
}) => (
  <a
    href={href}
    className={`text-[25px] ${["/new-arrivals", "/closeout"].includes(href ?? "") ? "font-bold" : ""} md:block md:w-full md:px-1 md:py-1 md:text-sm md:text-black md:hover:bg-blue md:hover:text-white`}
  >
    {children}
  </a>
);

export const MenuBrandLink: React.FC<
  React.PropsWithChildren<{ href?: string }>
> = ({ href, children }) => (
  <a
    href={href}
    className="flex h-[80px] max-w-[250px] items-center justify-center"
  >
    {children}
  </a>
);

export const MenuBrandLogo: React.FC<
  React.PropsWithChildren<{
    src: { gray: string; white: string; color: string };
    alt?: string;
  }>
> = ({ src, alt }) => {
  const { isMobile } = useBreakpoints();
  const [isHover, setIsHover] = React.useState(false);

  if (isMobile)
    return (
      <img
        className="max-h-[85%] max-w-[85%]"
        alt={alt}
        src={src.white}
      />
    );

  return (
    <img
      onMouseEnter={() => setIsHover(true)}
      onMouseLeave={() => setIsHover(false)}
      className="max-h-[85%] max-w-[85%]"
      alt={alt}
      src={isHover ? src.color : src.gray}
    />
  );
};

const MenuItem: React.FC<React.PropsWithChildren> = ({ children }) => (
  <li className="md:p-[0.125rem]">{children}</li>
);

export default MenuItem;
